import React, { Fragment, useEffect, useState } from "react";
import util from "../../../../utils/miniUtils";
import { Modal, Card, Row, Col } from "react-bootstrap";

export default function ProductsDetail( { show, handleClose, product_id } ) {
    const [product, setProduct] = useState( null );

    useEffect( () => {
        if ( product_id ) {
            getProductDetail().then( null );
        }
    }, [product_id] );

    const getProductDetail = async () => {
        try {
            if ( product_id === null ) return;
            const request = await util.axios.get(
        `product/data/activity/${product_id}`
            );
            const { error, msg, data } = request.data;
            if ( error ) throw msg;
            setProduct( data );
        } catch ( e ) {
            util.handleError( e );
        }
    };

    if ( product === null ) {
        return util.LOADING_SCREEN( true );
    }

    return (
        <Fragment>
            <Modal show={show} size={"xl"} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title as="h2">
            Actividad de Producto
            #{util.zeroPad( product_id, 5 )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <Row className="mb-3">
                            <Col md={8} sm={12}>
                                <Card className="shadow-sm">
                                    <Card.Header as="h4">Detalles del Producto</Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col xs={12} md={6}>
                                                <p>
                                                    <strong>Creado por:</strong> {product.createdBy}
                                                </p>
                                                <p>
                                                    <strong>Fecha:</strong> {util.humanDateTime( product.createdAt )}
                                                </p>
                                                <p>
                                                    <strong>Artículo:</strong> {product.article}
                                                </p>
                                                <p>
                                                    <strong>Descripción:</strong> {product.description}
                                                </p>
                                                <p>
                                                    <strong>Mercado Libre:</strong> {product.internal_id || "N/D"}
                                                </p>
                                                <p>
                                                    <strong>ML-ID:</strong> {util.showItemId( product.internal_id ) }
                                                </p>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <p>
                                                    <strong>Categoría:</strong> {product.categoryName}
                                                </p>
                                                <p>
                                                    <strong>Local:</strong> {product.locationName}
                                                </p>
                                                <p>
                                                    <strong>Cantidad:</strong> {product.qty}
                                                </p>
                                                <p>
                                                    <strong>Precio:</strong> {util.currencyFormat( product.price )}
                                                </p>
                                                <p>
                                                    <strong>Marca:</strong> {product.brand}
                                                </p>
                                                <p>
                                                    <strong>Modelo:</strong> {product.model}
                                                </p>
                                                <p>
                                                    <strong>Del Año:</strong> {product.year}
                                                </p>
                                                <p>
                                                    <strong>Hasta Año:</strong> {product.year_end}
                                                </p>
                                                <p>
                                                    <strong>Tamaño:</strong> {product.size}
                                                </p>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4} sm={12}>
                                {product?.images?.length > 0 && (
                                    <Card className="shadow-sm">
                                        <Card.Header as="h4">Fotografías</Card.Header>
                                        <Card.Body>
                                            <Row>
                                                {product.images.map( ( image, index ) => (
                                                    <Col key={index} xs={6} className="mb-2">
                                                        <a href={image.url} target="_blank" rel="noreferrer">
                                                            {/* Actualizado para que las imágenes sean cuadradas */}
                                                            <img
                                                                src={image.url}
                                                                alt="Producto"
                                                                className="img-fluid rounded border"
                                                                style={{
                                                                    width: "100%",
                                                                    aspectRatio: "1/1",
                                                                    objectFit: "cover",
                                                                }}
                                                            />
                                                        </a>
                                                    </Col>
                                                ) )}
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} sm={12} className="mb-3">
                                <Card className="shadow-sm">
                                    <Card.Header as="h4">Entradas</Card.Header>
                                    <Card.Body className="p-0">
                                        <TableOfInventoryModifications data={product.added} />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6} sm={12} className="mb-3">
                                <Card className="shadow-sm">
                                    <Card.Header as="h4">Salidas</Card.Header>
                                    <Card.Body className="p-0">
                                        <TableOfInventoryModifications data={product.removed} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
}

function TableOfInventoryModifications( { data } ) {
    const [currentPage, setCurrentPage] = useState( 0 );
    const rowsPerPage = 5;
    const totalPages = Math.ceil( data.length / rowsPerPage );

    const handleNext = () => {
        setCurrentPage( ( prev ) => Math.min( prev + 1, totalPages - 1 ) );
    };
    const handlePrev = () => {
        setCurrentPage( ( prev ) => Math.max( prev - 1, 0 ) );
    };

    const startIndex = currentPage * rowsPerPage;
    const currentData = data.slice( startIndex, startIndex + rowsPerPage );

    return (
        <div className="table-responsive" style={{ fontSize: "13px" }}>
            <table className="table table-striped table-hover align-middle shadow-sm border rounded table-sm">
                <thead className="table-dark">
                    <tr>
                        <th className="text-center" style={{ width: "35%" }}>
              Usuario
                        </th>
                        <th className="text-center" style={{ width: "20%" }}>
              Cantidad
                        </th>
                        <th className="text-center" style={{ width: "45%" }}>
              Fecha
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {currentData.length === 0 ? (
                        <tr>
                            <td colSpan={3} className="text-center text-muted py-4">
                Sin movimientos
                            </td>
                        </tr>
                    ) : (
                        currentData.map( ( item, i ) => (
                            <tr key={i} className={i % 2 === 0 ? "table-light" : ""}>
                                <td className="text-center fw-semibold">{item.userName}</td>
                                <td className="text-center">
                                    {/* <span className="badge bg-primary fs-6 px-3 py-2 shadow-sm"> */}
                                    {item.qty}
                                    {/* </span> */}
                                </td>
                                <td className="text-center text-secondary small">
                                    {util.humanDateTime( item.date )}
                                </td>
                            </tr>
                        ) )
                    )}
                </tbody>
            </table>
            {totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-2">
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={handlePrev}
                        disabled={currentPage === 0}
                    >
            Anterior
                    </button>
                    <span>
            Página {currentPage + 1} de {totalPages}
                    </span>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={handleNext}
                        disabled={currentPage === totalPages - 1}
                    >
            Siguiente
                    </button>
                </div>
            )}
        </div>
    );
}